module.exports = __webpack_public_path__ + "static/depauw.ebecc064.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/depauw.png
// module id = 2181
// module chunks = 61762850755587